import { BasicInfo, Role } from '.';

export enum TeamMemberStatus {
  'ACTIVE' = 'ACTIVE',
  'INACTIVE' = 'INACTIVE',
  'PENDING' = 'PENDING',
}

export interface TeamMember {
  id: number;
  companyBasicInfo: BasicInfo;
  firstName: string;
  lastName: string;
  countryCode: string;
  phoneNumber: string;
  email: string;
  status: TeamMemberStatus;
  gender: Gender;
  role: Role;
  profilePictureSize: null | string;
  profilePictureFilePath: null | string;
  profilePictureFileName: null | string;
  profilePictureURL: null | string;
  profilePictureThumbnailSize: null | string;
  profilePictureThumbnailFilePath: null | string;
  profilePictureThumbnailFileName: null | string;
  profilePictureThumbnailURL: null | string;
  password: string;
  activationToken: null | string;
  partner: any;
}

export interface Partner {
  id: number;
  name: string;
}

export interface PaginatedTeamMember {
  page: number;
  size?: number;
  name?: string;
  companyId: number;
  status?: TeamMemberStatus;
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}
